import { render } from "./OrderStatusUpdateForm.vue?vue&type=template&id=3565c5e5"
import script from "./OrderStatusUpdateForm.vue?vue&type=script&lang=js"
export * from "./OrderStatusUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__